class SocialVideos extends HTMLElement {
  constructor() {
    super();
  }

  get selectors() {
    return {
      player: "[data-social-video-player]",
      thumbnail: "[data-social-video-thumbnail]",
      modal: {
        container: "[data-social-videos-modal]",
        closeButton: "[data-social-videos-modal-close]",
        slider: "[data-social-videos-detailed-slider]",
        slide: "[data-social-videos-detailed-slide]"
      },
      share: {
        openButton: "[data-social-videos-share-open]",
        closeButton: "[data-social-videos-share-close]",
        popup: "[data-social-videos-share-popup]"
      },
      products: {
        openButton: "[data-social-videos-products-open]",
        closeButton: "[data-social-videos-products-close]",
        popup: "[data-social-videos-products-popup]"
      }
    }
  }

  get attributes() {
    return {
      index: "data-index"
    }
  }

  get modifiers() {
    return {
      modal: {
        open: "open",
        productsShown: "products-shown"
      },
      sharePopup: {
        open: "open"
      },
      productsPopup: {
        open: "open"
      }
    }
  }

  get breakpoints() {
    return {
      desktop: 992,
      mobile: 375
    }
  }

  connectedCallback() {
    this.modalElement = this.querySelector(this.selectors.modal.container);
    this.modalSliderElement = this.querySelector(this.selectors.modal.slider);

    this.initPlayers();
    this.initModalSliderEvents();

    document.documentElement.customDelegate(
      "click",
      this.selectors.thumbnail,
      this.onThumbnailClicked.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.modal.closeButton,
      this.closeModal.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.share.openButton,
      this.openSharePopup.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.share.closeButton,
      this.closeSharePopup.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.products.openButton,
      this.openProductsPopup.bind(this)
    );

    document.documentElement.customDelegate(
      "click",
      this.selectors.products.closeButton,
      this.closeProductsPopup.bind(this)
    );
  }

  initPlayers() {
    const playerElements = [...this.querySelectorAll(this.selectors.player)];

    if (!playerElements.length) {
      return;
    }

    let playerOptions = {
      playsinline: true,
      hideControls: false,
      controls: [
        'mute'
      ],
      loop: {
        active: true
      }
    };

    if (window.innerWidth < this.breakpoints.desktop) {
      playerOptions = {
        ...playerOptions,
        storage: {
          enabled: false
        }
      };
    } else {
      playerOptions = {
        ...playerOptions,
        controls: [
          'progress',
          'current-time',
          'mute'
        ]
      };
    }

    this.players = playerElements.map((playerElement) => new Plyr(playerElement, playerOptions));
  }

  initModalSliderEvents() {
    this.modalSliderElement.swiperInstance.on("slideChange", (swiper) => {
      this.players[swiper.previousIndex].pause();
      this.players[swiper.activeIndex].play();
    });
  }

  onThumbnailClicked({ target }) {
    const thumbnail = target.closest(this.selectors.thumbnail);

    this.showDetailedView(thumbnail.getAttribute(this.attributes.index));

    setTimeout(() => {
      this.openModal();
    }, 250);
  }

  showDetailedView(itemIndex) {
    if (this.modalSliderElement) {
      this.modalSliderElement.swiperInstance.slideTo(itemIndex);
    }

    this.players[itemIndex].play();
  }

  openSharePopup(event) {
    const sharePopupElement = event.target.nextElementSibling;

    if (!sharePopupElement.classList.contains(this.modifiers.sharePopup.open)) {
      sharePopupElement.classList.add(this.modifiers.sharePopup.open);
    } else {
      sharePopupElement.classList.remove(this.modifiers.sharePopup.open);
    }
  }

  closeSharePopup(event) {
    const sharePopupElement = event.target.closest(this.selectors.share.popup);

    if (!sharePopupElement.classList.contains(this.modifiers.sharePopup.open)) {
      return;
    }

    sharePopupElement.classList.remove(this.modifiers.sharePopup.open);
  }

  openProductsPopup(event) {
    const productsPopupElement = event.target.closest(this.selectors.products.popup);

    if (!productsPopupElement.classList.contains(this.modifiers.productsPopup.open)) {
      productsPopupElement.classList.add(this.modifiers.productsPopup.open);
      this.modalElement.classList.add(this.modifiers.modal.productsShown);
    } else {
      productsPopupElement.classList.remove(this.modifiers.productsPopup.open);
      this.modalElement.classList.remove(this.modifiers.modal.productsShown);
    }
  }

  closeProductsPopup(event) {
    const productsPopupElement = event.target.closest(this.selectors.products.popup);

    if (!productsPopupElement.classList.contains(this.modifiers.productsPopup.open)) {
      return;
    }

    productsPopupElement.classList.remove(this.modifiers.productsPopup.open);
    this.modalElement.classList.remove(this.modifiers.modal.productsShown);
  }

  openModal(event) {
    if (event) {
      event.preventDefault();
    }

    bodyScrollLock.disableBodyScroll(this.modalElement);

    this.modalElement.classList.add(this.modifiers.modal.open);
  }

  closeModal(event) {
    if (event) {
      event.preventDefault();
    }

    this.players.forEach((player) => player.pause());

    this.modalElement.classList.remove(this.modifiers.modal.open);

    bodyScrollLock.enableBodyScroll(this.modalElement);
  }
}

if (!customElements.get("social-videos")) {
  customElements.define("social-videos", SocialVideos);
}
